import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";

import "./EditableCellByType.scss";

import DatePicker from "components/uiComponents/Datepicker";
import IndeterminateCheckbox from "components/uiComponents/IndeterminateCheckbox";
import ViewCell from "../ViewCell/ViewCell";

import useOutsideClick from "hooks/useOutSideClick";

import { displayType } from "../../model/types";
import { renderFieldByType } from "../../lib/renderFieldByType";
import { useRowValue } from "../../lib/useRowValue";

import { valueTypes } from "utils/builder/ResultClasses";

const EditableCellByType = (props) => {
  const { cell, isEditable, setIsEditable, setCellValue, row, setChoicesState, choicesState } = props;
  const customSelectRef = useRef();

  const { customPropertiesValues } = useSelector((state) => state.viewer);
  const [customPropertiesValueState, setCustomPropertiesValueState] = useState(
    []
  );

  const handleCheckboxChange = (isChecked, value) => {
    if (isChecked) {
      setCustomPropertiesValueState((prevState) => [...prevState, value]);
    } else {
      setCustomPropertiesValueState((prevState) =>
        prevState.filter((item) => item !== value)
      );
    }
  };

  useOutsideClick(customSelectRef, () => {
    const newValue = customPropertiesValueState
      .map(
        (item, i) =>
          item +
          `${customPropertiesValueState.length > 1 &&
            i !== customPropertiesValueState.length - 1
            ? "; "
            : ""
          }`
      )
      .join("");
    setCellValue({ value: newValue, cell, row });
  });

  const { value, setValue, validate, error } = useRowValue({
    cell,
    row,
  });

  const columnMetaData = cell.column.columnDef.meta;
  const cellDisplayType = columnMetaData.type || displayType.input;

  const multiplechoiceValuesFiltered =
    customPropertiesValues?.find(item => item?.name === cell.column.id) || {
      name: cell.column.id,
      values: columnMetaData?.existingValue,
    };
  const multiplechoiceValues = multiplechoiceValuesFiltered?.values;

  const onInputValueChange = (value) => {
    setValue(value);
  };
  
  const setValueHandler = () => {
    const isError = validate();
    const isDateField =
      cellDisplayType === valueTypes.customDate ||
      cellDisplayType === valueTypes.proDate ||
      cellDisplayType === valueTypes.date;
    
    if (isDateField && !value) {
      setIsEditable(false);

      return;
    };

    if (!isError) {
      setCellValue({ value, cell, row });
    };
  };

  const clearValue = (e) => {
    setValue(null);
    setCellValue({ value: null, cell, row });
  };

  const baseProps = {
    isEditable,
    cellDisplayType,
    setIsEditable,
    setChoicesState: setChoicesState,
    choicesState: choicesState,
    fieldProps: props,
  };

  switch (cellDisplayType) {
    case valueTypes.date:
    case valueTypes.customDate:
      case valueTypes.proDate:
      return renderFieldByType({
        ...baseProps,
        fieldComponent: (
          <DatePicker
          value={value || new Date()}
          onSetValue={setValueHandler}
          clearValue={clearValue}
          onChangeValue={(value) => {
            onInputValueChange(value);
          }}
        />
        ),
      });

    case valueTypes.customEnumSingle:
    case valueTypes.customEnumMulty:
    case valueTypes.proEnumSingle:
    case valueTypes.proEnumMulty:
      return renderFieldByType({
        ...baseProps,
        fieldComponent: (
          <div className="checkbox-dropdown" ref={customSelectRef}>
            {multiplechoiceValues?.map((elem) => {
              return (
                <div className="checkbox-dropdown__item">
                  {elem}
                  <IndeterminateCheckbox
                    checked={!!customPropertiesValueState.includes(elem)}
                    label={elem}
                    handleChange={(e) =>
                      handleCheckboxChange(e.target.checked, elem)
                    }
                  />
                </div>
              );
            })}
          </div>
        ),
      });

    default:
      return (
        <ViewCell
          cellDisplayType={cellDisplayType}
          setChoicesState={setChoicesState}
          choicesState={choicesState}
          onClick={() => {
            setIsEditable(true);
          }}
          {...props}
        />
      );
  }
};

export default EditableCellByType;
